import React, { ReactNode } from 'react';
import styled from 'styled-components';
import useTranslation from '../../translation/useTranslation';
import { Language } from './types';
import GridItem from './Grid.item';

export interface GroupProps {
  title?: Record<Language, string>;
  children: ReactNode;
}

function Grid({ title, children }: GroupProps) {
  const { language } = useTranslation();
  return (
    <GridGroup>
      {title && <Title>{title[language]}</Title>}
      <GridBase>{children}</GridBase>
    </GridGroup>
  );
}

export const GridGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const GridBase = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;

  @media (max-width: 340px) {
    grid-template-columns: 1fr;
  }
`;

export const Title = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;
`;

Grid.Item = GridItem;

export default Grid;
